import { useEffect } from "react";
import { observer } from "mobx-react-lite";
import "./Offers.scss";
import OffersSummary from "../../components/Offer/OffersSummary";
import offerStore from "../../stores/OfferStore";
import authStore from "../../stores/AuthStore";
import { UserRoles } from "../../stores/AuthStore/types";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import configStore, { Flags } from "../../stores/ConfigStore";
import useTranslation from "../../hooks/useTranslation";

const Offers = observer(() => {
  const { t } = useTranslation();

  useEffect(() => {
    offerStore.fetchLawyerOffers();
  }, []);

  return (
    <div className="offersContainer container">
      <h2>{t("your-offers")}</h2>
      <OffersSummary rawOffers={offerStore.lawyerOffers} />
      <div className="seeMore">
        {!authStore.userHasRole(UserRoles.PREMIUM) &&
          configStore.getFlag(Flags.isPremiumEnabled) && (
            <Link to={"/premium"}>
              <Button color={"warning"} size={"large"} variant={"outlined"}>
                {t("more-offers-with-premium", [
                  `${offerStore.lawyerOffers.length}`,
                  `${configStore.appConfig.offerLimit}`,
                ])}
              </Button>
            </Link>
          )}
      </div>
    </div>
  );
});

export default Offers;
